export default {"src":"/login-app/[GIT_HASH]/_next/static/media/slack_color.4cb43596.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};